var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#880C55",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 396 c-43 -43 -44 -78 -3 -134 27 -37 36 -42 69 -42 33 0 42 5 69 42 41 56 40 91 -3 134 -46 46 -86 46 -132 0z m100 -32 c26 -26 18 -34 -34 -34 -27 0 -50 4 -50 9 0 16 31 41 50 41 10 0 26 -7 34 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 330 l0 -50 120 0 120 0 0 50 0 50 -120 0 -120 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 170 l0 -50 120 0 120 0 0 50 0 50 -120 0 -120 0 0 -50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 144 c3 -64 23 -88 56 -68 23 15 28 44 8 44 -9 0 -16 5 -16 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 -7 10 -15 10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 5 15 10 0 6 -18 10 -40 10 l-41 0 3 -56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutAccess);
export default __webpack_public_path__ + "static/media/About_Access.3292058fdd35715e7420a90e7d07ebb9.svg";
export { ForwardRef as ReactComponent };